import {ContentfulCtaBanner} from '@github-ui/swp-core/components/contentful/ContentfulCtaBanner'
import {Section} from '@primer/react-brand/esm'

import type {CtaSectionContent} from '../../content'

type Props = {
  contentfulContent: CtaSectionContent
}

export function CtaSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const ctaBanner = contentfulContent.ctaBanner

  return (
    <Section id={sectionId} fullWidth paddingBlockStart="none" paddingBlockEnd="none">
      {ctaBanner ? <ContentfulCtaBanner component={ctaBanner} /> : null}
    </Section>
  )
}
